import {
  AppBar,
  Button,
  CircularProgress,
  Grid,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SummaryRadarCard from "../../../Common/SummaryRadarCard";
import { InterestPieChart } from "./InterestsPieChart";
import { JobMatches } from "./JobMatches";
import { SkillsBackpackSummary } from "./JobSkillSummary";
import NewSkills from "./NewSkills";
import CoinLevels from "./CoinLevels";
export const CandidateSummaryView = (props) => {
  const {
    candidate,
    user,
    isOnPrintMode,
    groupSkillsBackpack = false,
    getSkillsInfo: gsb,
    rewards,
    addNewSkill,
    editSkillLevel,
    saveSkills,
    createValidationRequest,
  } = props;
  const { skills_names = [], userID } = candidate;
  const [newSkillPanel, newSkillPanelSet] = useState(false);
  const [currentCandidate, setCurrentCandidate] = useState(false);
    useEffect(() => {
      async function getSkillsInfo() {
        if (candidate && userID !== currentCandidate) {
          setCurrentCandidate(userID)
          gsb();
        }
      }
      getSkillsInfo();
    }, [candidate, gsb]);

    if (!candidate) {
      return (
        <Grid>
          <Grid container item xs justify="center">
            <CircularProgress size={25} thickness={4} />
          </Grid>
        </Grid>
      );
    }
    if (!candidate.assessmentCompleted && !candidate.reAssessmentDue) {
      return (
        <Grid>
          <Grid container item xs justify="center">
            <Typography variant="subtitle2">
              This candidate has not completed the assessment yet.
            </Typography>
          </Grid>
        </Grid>
      );
    }

    const {
      latestAssessmentResult: {
        interests: { results = {} },
      } = {},
      assessmentCreatedAt,
      latestAssessmentCreatedAt,
      reassessmentTriggeredAt,
      isInterventionOngoing,
    } = candidate; // These variables are only used in the commented-out section.
    return (
      <Grid>
        {user.organisation === "sds" ? (
          <>
            <Grid item size>
              <JobMatches
                isOnPrintMode={isOnPrintMode}
                candidateDetails={candidate}
                candidateStyles={candidate.stylesGraphData}
                // candidateInterestsScore={candidateInterestsScore}
              />
            </Grid>
          </>
        ) : null}
        {candidate.stylesGraphData ? (
          <>
            <Grid item>
              <CoinLevels data={rewards}/>
            </Grid>
            {(candidate.skillsInfo || []).length ? (
            <Grid item size>
              <Grid container direction="column">
                <Grid item size>
                  <AppBar
                    position="static"
                    color="default"
                    elevation={0}
                    sx={{ mt: 5, mb: 2.5 }}
                  >
                    <Toolbar
                      variant="dense"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        textAlign: "center",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Typography variant="h6" color="inherit">
                        Skills
                      </Typography>
                      <Button style={{"marginLeft": 5}} variant="contained" color="primary" size="small" onClick={() => newSkillPanelSet(true)}>
                        Add New Skills
                      </Button>
                    </Toolbar>
                  </AppBar>
                </Grid>
                <Grid item size>
                  <SkillsBackpackSummary
                    isOnPrintMode={isOnPrintMode}
                    skillsInfo={candidate.skillsInfo}
                    groupSkillsBackpack={groupSkillsBackpack}
                    editSkillLevel={editSkillLevel}
                    saveSkills={saveSkills}
                    createValidationRequest={createValidationRequest}
                  />
                </Grid>
              </Grid>
            </Grid>
          ) : null}
          <NewSkills 
            open={newSkillPanel} 
            closePanel={async (newSkills) => {
              newSkillPanelSet(false)
              if(newSkills && newSkills.length > 0){
                await addNewSkill(newSkills)
              }
            }} 
            existingSkills={skills_names}
          />
            <Grid item size>
              <AppBar
                position="static"
                color="default"
                elevation={0}
                sx={{ mt: 5, mb: 2.5 }}
              >
                <Toolbar
                  variant="dense"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    textAlign: "center",
                    border: "1px solid #ddd",
                  }}
                >
                  <Typography variant="h6" color="inherit">
                    Work Styles
                  </Typography>
                </Toolbar>
              </AppBar>
            </Grid>
            <Grid item size="grow">
              <Grid container justify="center" alignItems="center">
                <Grid item size="grow">
                  <SummaryRadarCard data={candidate.stylesGraphData} dataKey="name" />
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : null}
        {candidate.interestsGraphData  && (
          <Grid item size="grow">
          <div style={{ marginTop: "2em" }}>
            <AppBar
              position="static"
              color="default"
              elevation={0}
              sx={{ mt: 5, mb: 2.5 }}
            >
              <Toolbar
                variant="dense"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                <Typography variant="h6" color="inherit">
                  Interests
                </Typography>
              </Toolbar>
            </AppBar>
            <InterestPieChart interests={candidate.interestsGraphData} />
          </div>
        </Grid>
        )}
      </Grid>
    );
};
